import { combineReducers } from 'redux-immutable'
import employeeLevelsCreateReducer from './employee-levels-create-reducer'
import employeeLevelsListReducer from './employee-levels-list-reducer'
import employeeLevelsEditReducer from './employee-levels-edit-reducer'
import employeeLevelsGetReducer from './employee-levels-get-reducer'
import employeeLevelsDeactivateReducer from './employee-levels-deactivate-reducer'
import employeeLevelsExportReducer from './employee-levels-export-reducer'

export default combineReducers({
  employeeLevelsCreate: employeeLevelsCreateReducer,
  employeeLevelsList: employeeLevelsListReducer,
  employeeLevelsEdit: employeeLevelsEditReducer,
  employeeLevelsGet: employeeLevelsGetReducer,
  employeeLevelsDeactivate: employeeLevelsDeactivateReducer,
  employeeLevelsExport: employeeLevelsExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/index.js